import { Footer as MastheadFooter } from '@spotify-internal/masthead-react';

import { SPOTIFYCOM_URL } from 'lib/shared/config/config';
import { getMastheadDirOverride, useMarketInfo } from 'context/MarketInfo/MarketInfoProvider';
import { MastheadFooterType } from 'etc/types';
import { useIsPlainPage } from 'context/PlainPage/plainPage';

const FALLBACK_DATA = {
  brand: {
    href: SPOTIFYCOM_URL,
    alt: 'Spotify',
  },
  topLinkGroups: [],
  socialLinks: [],
  bottomLinks: [],
  country: {
    name: 'Select market',
    flagCode: 'gb',
    href: `${SPOTIFYCOM_URL}/select-your-market/`,
  },
  copyrightNotice: `© ${new Date().getFullYear()} Spotify AB`,
} as MastheadFooterType;

interface Props {
  footerData?: MastheadFooterType;
}

const Footer = ({ footerData = FALLBACK_DATA }: Props) => {
  const { market } = useMarketInfo();
  const isPlainPage = useIsPlainPage();

  if (isPlainPage) {
    return null;
  }

  return (
    <div dir={getMastheadDirOverride(market)}>
      <MastheadFooter {...footerData} />
    </div>
  );
};

export default Footer;
